export default "<app-patient-list></app-patient-list>\r\n";